<template>
    <transition name="fade">
        <div class="overlay" v-if="show" @click="clickOutside">

            <div class="modal--lg">

                <header class="modal__header">

                    <slot name="header">

                    </slot>

                    <a class="modal__header--close" @click.prevent="close" href="#">

                        <img src="/images/close-btn.svg">

                    </a>

                </header>

                <section class="modal__content">

                    <slot name="content">

                    </slot>

                </section>

                <footer class="modal__footer">

                    <slot name="footer">

                    </slot>

                </footer>

            </div>

        </div>
    </transition>


</template>

<script>
    export default{
        props:{
            show:{
                type: Boolean
            }
        },
        watch:{
            show: function(value){
                 if(value)
                 {
                      document.body.className = 'no-scroll';
                 }
                 else{
                      document.body.className = '';
                 }
            }
        },
        methods:{
            close: function(){
                this.$emit('close');
            },
            clickOutside: function(e){
                if(e.target.classList[0] == 'overlay')
                {
                    this.close();
                }
            },

        }

    }



</script>
